import axios from "axios";

export function getAchievements(payload) {
  return axios.get(`https://sisapi.aden.org/api/insignias/${payload}`);
}
